(function () {
  function getLang() {
    // Shopify usually sets <html lang="es"> / "en"
    const lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (lang.startsWith("es")) return "es";
    return "en";
  }

  const DICT = {
    en: {
      delivery_lead: "Order today and receive your order between",
      and_word: "and",
      steps: { "Pedido": "Ordered", "Preparado": "Prepared", "Entregado": "Delivered" },

      size_guide_button: "SIZE GUIDE"
    },
    es: {
      delivery_lead: "Pide hoy y recibe tu pedido entre",
      and_word: "y",
      steps: { "Pedido": "Pedido", "Preparado": "Preparado", "Entregado": "Entregado" },

      size_guide_button: "GUÍA DE TALLAS"
    }
  };

  function setText(el, txt) {
    if (!el) return;
    if (el.textContent.trim() === txt) return;
    el.textContent = txt;
  }

  function localizeDeliveryWidget(lang) {
    const t = DICT[lang];

    // Lead sentence inside the widget
    const p = document.querySelector(".delivery-widget__auto .msg__container p");
    if (p) {
      // Keep the dates spans, only replace the leading text + the connector
      // This widget typically: "Pide hoy... <span>Feb 19</span> y <span>Feb 23</span>"
      // We'll rebuild lightly by swapping first text node + the "y/and" node.
      const strongSpans = p.querySelectorAll("strong span");
      if (strongSpans.length >= 2) {
        // Ensure connector word exists between dates
        // Find any text nodes between first and second strong blocks and set them to " y " / " and "
        const nodes = Array.from(p.childNodes);

        // Replace the first text chunk (before first <strong>)
        for (const n of nodes) {
          if (n.nodeType === Node.TEXT_NODE && n.textContent.trim().length) {
            n.textContent = t.delivery_lead + " ";
            break;
          }
        }

        // Replace the connector between the two date blocks
        // Find the first TEXT_NODE that contains "y" or "and" after first strong
        let sawFirstStrong = false;
        for (const n of nodes) {
          if (n.nodeType === Node.ELEMENT_NODE && n.tagName === "STRONG") {
            if (!sawFirstStrong) sawFirstStrong = true;
            else break;
          }
          if (sawFirstStrong && n.nodeType === Node.TEXT_NODE) {
            // normalize connector
            n.textContent = " " + t.and_word + " ";
            break;
          }
        }
      }
    }

    // Step titles: Pedido / Preparado / Entregado
    document.querySelectorAll(".delivery-widget__auto .title__content").forEach((el) => {
      const key = el.textContent.trim();
      if (t.steps[key]) setText(el, t.steps[key]);
    });
  }

  function localizeKiwiSizing(lang) {
    const t = DICT[lang];

    // Button text "GUIA DE TALLAS"
    document.querySelectorAll(".ks-chart-modal-link ._ks_text").forEach((el) => {
      setText(el, t.size_guide_button);
    });
  }

  function run() {
    const lang = getLang();
    localizeDeliveryWidget(lang);
    localizeKiwiSizing(lang);
  }

  // Run once now + after apps inject HTML
  run();

  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Also re-run after Shopify section refreshes
  document.addEventListener("shopify:section:load", run);
})();
